module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SearchView.js"));
	}, "SearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SearchView!./src/pages/Learn/Search/SearchView.js
// module id = 1235
// module chunks = 438